<template>
    <div class="search_filter_wrap">
      <div class="search_item_wrap">
        <div class="filter_category_box">
          <el-select id="category" v-model="searchOption" class="my_filter select"
                     popper-class="category_select"
                     :popper-append-to-body="false">
            <el-option :value="'ina'" :label="$t('subject')"></el-option>
            <el-option :value="'hash'" :label="$t('hashtag')"></el-option>
            <el-option :value="'orni'" :label="$t('k_creator')"></el-option>
          </el-select>
        </div>
        <div class="search_input">
          <el-input :placeholder="$t('st')" v-model="searchInput"
                    @input="setData('searchInput',searchInput)"
                    @keypress.enter="setFilterFunc(searchOption,searchInput)"/>
          <button class="search_btn" @click="setFilterFunc(searchOption,searchInput)"><span>{{ $t('search') }}</span>
            <img src="@/assets/image/main/search_btn.png"></button>
        </div>
        <div class="list_type">
          <button class="list_type_btn listType"
                  v-show=" listChange === 'thumbnail'"
                  @click="listTypeChange('list')"></button>
          <button class="list_type_btn "
                  v-show=" listChange === 'list'"
                  @click="listTypeChange('thumbnail')"></button>
        </div>
        <div class="end_filter">
          <!--            <button class="filter_btn one" @click="openModal('filter-modal')"></button>-->
          <el-popover
              popper-class="top_500"
              placement=""
              width="435"
              trigger="click"
              :open-delay="300"
              :offset="0"
              :append-to-body="false"
              :popper-options="{
                          boundariesElement: 'body',
                          gpuAcceleration: true,
                          positionFixed: true,
                          preventOverflow: true,
                        }">
            <el-button slot="reference" class="filter_btn two"
                       @click="changeCheck('filterEndCheck')"></el-button>
            <div class="popup_tail"></div>
            <div class="popup_bg">
              <div class="popup_inner">
                <div class="inner_top"><span class="title">{{ $t('filter') }}</span></div>
                <div class="inner_middle">
                  <div class="sub_title">{{ $t('category') }}</div>
                  <div class="status_wrap">
                    <el-checkbox-group v-model="filterCategory"
                                       @change="setFilterFunc('ccid', filterCategory)">
                        <el-checkbox v-for="data in competitionCategoryList"
                                     :key="`category${data.cc_idx}`" :label="data.cc_idx">
                            {{ data.cc_name }}
                        </el-checkbox>
                    </el-checkbox-group>

                  </div>
                  <div class="sub_title">{{ $t('status') }}</div>
                  <div class="edition_wrap">
                    <el-checkbox-group v-model="filterStatus"
                                       @change="setFilterFunc('st', filterStatus)">
                      <el-checkbox :label="0" >{{ $t('scheduled_to_proceed') }}</el-checkbox>
                      <el-checkbox :label="1" >{{ $t('in_process2') }}</el-checkbox>
                      <el-checkbox :label="2">{{ $t('under_review') }}</el-checkbox>
                      <el-checkbox :label="3">{{ $t('p_completed') }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="sub_title">{{ $t('prize') }}</div>
                  <div class="price_wrap">
                    <el-input v-model="filterPrice[0]" class="el_price_input el_input_num"
                              type="number"
                    />
                    <span> Mg</span>
                    <span class="first_input_step">~</span>
                    <el-input v-model="filterPrice[1]" class="el_price_input el_input_num"
                              type="number"
                    />
                    <span> Mg</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="wrapper_bottom" @click="changeCheck('filterEndCheck')">
              <button class=""@click="setFilterFunc('pr', filterPrice)">{{ $t('apply2') }}</button>
            </div>
          </el-popover>
        </div>
        <div class="filter_sort_box">
          <el-select id="sort_select" v-model="sortOption" class="sort_filter select"
                     popper-class="category_select"
                     :popper-append-to-body="false"
                     @change="sortChange(sortOption)">
            <el-option :value="'im_real_hit'" :label="$t('voteDesc')"></el-option>
            <el-option :value="'i.updated_at'" :label="$t('b_update')"></el-option>
            <el-option :value="'im_like'" :label="$t('scoreDesc')"></el-option>
          </el-select>
        </div>
      </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import {mapState} from "vuex";

export default {
  name: "CompetitionFilterModalFilterLayout",
  mixins: [],
  components: {

  },
  inject: [],
  provide() {
    return {

    }
  },
  props: {},
  data() {
    return {
      filterStatus:[],
      filterCategory:[],
      filterPrice:[],
      listChange: 'list',
      searchMsg: '',
      searchOption: 'ina',
      sortOption: 'i.updated_at',
      searchInput: '',
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
      ...mapState({
          competitionCategoryList: state => state.competitionCategory.competitionCategoryList,
      })
  },
  methods: {
    openModal(name) {
      this.$modal.show(name);
    },

    searchSubmit() {
      // 검색 입력 후 ,
      this.searchCheck = true;
      this.$router.push('/search');
    },
    listTypeChange() {
      EventBus.$emit('changeListType');
    },
    sortChange(data) {
      if (data === 'priceAsc') {
        this.setFilterFunc('obt', 'i_price');
        this.setFilterFunc('obs', 'asc');
      } else if (data === 'priceDesc') {
        this.setFilterFunc('obt', 'i_price');
        this.setFilterFunc('obs', 'desc');
      } else {
        this.setFilterFunc('obt', data);
        this.setFilterFunc('obs', 'desc');
      }
    },
    setFilterFunc(key, value) {
      this.setFilter(key, value);
    },
    setData(key, value) {
      this[key] = value;
    },
    changeCheck(dataName) {
      this[dataName] = !this[dataName];
      if (this[dataName]) {
        this[dataName] = true;
      } else {
        this[dataName] = false;
      }
      if (this[dataName]) {
        this.btnCheck = false;
      }
    },
    setterFilterDataInData() {
      let classnames = Object.keys(this.filterData);
      classnames.forEach(classname => {
        let obj = this.filterData[classname];
        let type = filterConfig[obj.key].type;
        if (this.hasOwnProperty(classname)) {
          // this[classname] =
          if (type == 'query') {
            this[classname] = obj.query;
            if (this.hasOwnProperty(classname + 'Option')) {
              this[classname + 'Option'] = obj.key;
            }
          } else if (type === 'between') {
            this[classname] = [obj.start, obj.end];
          } else if (type === 'match') {
            if (isNaN(obj.value)) {
              this[classname] = obj.value;
            } else {
              this[classname] = Number(obj.value);
            }

          } else if (type === 'terms') {
            this[classname] = obj.terms;
          }

        }
      })
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
